// extracted by mini-css-extract-plugin
export default {"contents":"dF-z","sectionHeading":"eF-z"};